import type { GameMeta } from "../../common/gameMeta.js";
import type { DotDashVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Dot Dash",
	minPlayers: 1,
	maxPlayers: 8,
	description: "Chain same-colored dots before anyone else can",
	instructions: "Drag to connect matching dots in any direction. Longer chains score exponentially more (n²). 60 seconds — highest score wins!",
	mobileBrowserCompatible: true,
	showScores: true,
	modifiers: [
		{
			id: "hotColors",
			label: "Hot Colors",
			instructions: "Red and purple dots score 2× — hunt the rare ones!",
			config: { colorMultipliers: [2, 1, 1, 1, 2] } satisfies Partial<DotDashVariantConfig>,
		},
		{
			id: "blitz",
			label: "Blitz",
			instructions: "Only 30 seconds — move fast!",
			config: { roundDuration: 30 } satisfies Partial<DotDashVariantConfig>,
		},
		{
			id: "cooldown",
			label: "Cooldown",
			instructions: "After each chain you're locked out for 5 seconds — make every move count!",
			config: { lockoutDuration: 5 } satisfies Partial<DotDashVariantConfig>,
		},
	],
} satisfies GameMeta;
